import React from "react";
import CustomPageRenderer from "../CustomPageRenderer";

const createManagedPage = (forcedSlug) => {
  const ManagedPage = () => <CustomPageRenderer forcedSlug={forcedSlug} />;
  ManagedPage.displayName = `Website${forcedSlug.charAt(0).toUpperCase()}${forcedSlug.slice(1)}Page`;
  return ManagedPage;
};

export const WebsiteHomePage = createManagedPage("home");
export const WebsiteAboutPage = createManagedPage("about");
export const WebsiteAcademicsPage = createManagedPage("academics");
export const WebsiteAdmissionsPage = createManagedPage("admissions");
export const WebsiteFacilitiesPage = createManagedPage("facilities");
export const WebsiteResultsPage = createManagedPage("results");
export const WebsiteAnnouncementsPage = createManagedPage("announcements");
export const WebsiteNewsPage = createManagedPage("news");
export const WebsiteCareersPage = createManagedPage("careers");
export const WebsiteContactPage = createManagedPage("contact");

